<template>
    <div>
        <h4 class="switch-title">
            <b-badge variant="danger btn-red">Admin</b-badge>
            托姆自動計算開關
        </h4>
        <div class="switch-item-list">
            <div class="switch-item" v-for="(data_agent, key_agent, idx_agent) in agent_switches" :key="idx_agent">
                <div class="switch-item-name">{{ data_agent.name }}</div>
                <label class="switch switch-success">
                    <input type="checkbox" class="switch-input" v-model="data_agent.value" @change="update_AgentSwitch_Settings">
                    <span class="switch-slider"></span>
                </label>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import AgriLoading  from '@/views/components/AgriLoading'

export default {
    props: {
        cropperiodID: {
            type: [String, Number],
            default: undefined,
        },
        projectDetail: {
            type: Object,
            default: function () { return {} },
        },
        cropperiodDetail: {
            type: Object,
            default: function () { return {} },
        },
    },
    components: {
        AgriLoading,
    },
    data () {
        return {
            loading: false,
            uploading: false,
            origin_data: {},
            agent_switches: {
                // 'growth_stage': {
                //     value: false,
                //     name: '生長期 Growth Stage',
                //     description: '',
                // },
                // 'stress_alert': {
                //     value: false,
                //     name: '預警 Stress Alert',
                //     description: '',
                // },
                // 'weekly_report': {
                //     value: false,
                //     name: '週報 Weekly Report',
                //     description: '',
                // },
                // 'monthly_report': {
                //     value: false,
                //     name: '月報 Monthly Report',
                //     description: '',
                // },
                // 'period_report': {
                //     value: false,
                //     name: '履歷報 Period Report',
                //     description: '',
                // },
            },
        }
    },
    mounted ()
    {
        this.agent_switches = this.$tools.data.deepCopy_object( this.list_agent_switches.cropperiod )
        this.get_AgentSwitch_Settings()
    },
    computed:
    {
        ...mapState({
            'list_agent_switches': state => state.admin.agent_switches,
        }),
    },
    watch: {

        cropperiodID (val, oldVal)
        {
            this.get_AgentSwitch_Settings()
        },

    },
    methods: {

        get_AgentSwitch_Settings ()
        {
            if ( this.cropperiodID != undefined )
            {
                this.loading = true;
                const options = {
                    method: 'GET',
                    url: this.$config.getAPI_URL('Cropperiod_AgentSwitch', { cropperiodID: this.cropperiodID }),
                }
                this.$http(options)
                    .then(res => {
                        this.loading = false;

                        this.origin_data = res.data.agent_switches;

                        for (let _agent in this.agent_switches)
                        {
                            if ( res.data.agent_switches[ _agent ] != undefined )   this.agent_switches[ _agent ].value = res.data.agent_switches[ _agent ]
                            else                                                    this.agent_switches[ _agent ].value = false
                        }
                    })
                    .catch(err => {
                        this.loading = false;
                    })
            }
        },

        update_AgentSwitch_Settings ()
        {
            this.uploading = true;
            let _data = {}
            for (let _agent in this.agent_switches)
            {
                _data[ _agent ] = this.agent_switches[ _agent ].value
            }
            const options = {
                method: 'PUT',
                url: this.$config.getAPI_URL('Cropperiod_AgentSwitch', { cropperiodID: this.cropperiodID }),
                data: _data
            }
            this.$http(options)
                .then(res => {
                    // this.getCropperiod(this.cropInfo.id);
                    this.uploading = false;
                    this.$toastr.s(this.$t('other.update_succeeded'), '托姆自動計算開關');
                    this.get_AgentSwitch_Settings()
                })
                .catch(err => {
                    this.uploading = false;
                    this.$toastr.e(this.$t('other.update_failed') + '<br>' + err.data.status + '<br>' + err.data.message,
                                    '托姆自動計算開關');
                })
            
            
            // 送出使用者操作紀錄 --------------------
            let _query = {}
            for (let _agent in this.agent_switches)
            {
                if ( this.origin_data[ _agent ] != this.agent_switches[ _agent ].value )
                _query[ _agent ] = this.origin_data[ _agent ] + ' => ' + this.agent_switches[ _agent ].value
            }

            let _OPLog = {
                user_id: this.$store.state.user.id,
                type: 'write',
                detail: {
                    page: 'cropperiod',
                    action: 'update agent switch',
                    querySettings: _query,
                    pageInfo: {
                        'project ID':    this.projectDetail.id,
                        'project name':  this.projectDetail.name,
                        'cropperiod ID':    this.cropperiodDetail.id,
                        'cropperiod name':  this.cropperiodDetail.name,
                        'cropperiod status': this.cropperiodDetail.status,
                    },
                },
            }
            this.$store.dispatch('user/createLog', _OPLog).then( res => {}).catch( err => {})
            // 送出使用者操作紀錄 --------------------
        },
    },
}
</script>

<style lang="scss" scoped>

.switch-title
{
    color: #3b7564;
    padding: 5px 15px 10px 15px;
    margin-bottom: 10px;
    border-bottom: 1px solid #badf8a;
}
.switch-item-list
{
    text-align: left;
    padding-left: 3%;
}
.switch-item
{
    margin: 8px;
}
.switch-item-name
{
    display: inline-block;
    vertical-align: top;
    margin-right: 8px;
    font-size: 1.2rem;
}

</style>